<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <BasePushButton
          variant="fill"
          size="sm"
          bold
          class="add-form-button"
          icon="file-filled"
          bgColor="grey-10"
          textColor="white"
          @click="createNew"
        >
          {{ $t("checklists.btn_new") }}
        </BasePushButton>
      </template>
    </Header>

    <PageContainer contentClass="checklists-forms-global-container">
      <div class="gap-row-md">
        <BaseSearchInput
          v-model="search"
          size="md"
          :placeholder="$t('checklists.search_ph')"
        />

        <div class="summary-block">
          <div class="qrw-heading-sm grey-10-color bold">
            {{ $tc("checklists.forms_noun", templates.length) }}
          </div>
          <div class="tags-filter" v-if="allTags.length">
            <BaseTag
              size="md"
              @click="selectedTag = null"
              :active="!selectedTag"
              >{{ $t("checklists.filter_all") }}</BaseTag
            >
            <BaseTag
              size="md"
              v-for="tag in allTags"
              :key="tag"
              :active="selectedTag == tag"
              @click="selectedTag = tag"
              >{{ tag }}</BaseTag
            >
          </div>
        </div>

        <div class="templates-grid">
          <ChecklistFormCard
            class="grid-card"
            :template="template"
            @click="selectTemplate(template)"
            v-for="template in filteredTemplates"
            :key="template._id"
          />
        </div>
      </div>
    </PageContainer>


  </div>
</template>

<script>
import ChecklistFormCard from "@/components/checklists/ChecklistFormCard.vue";

import ChecklistsAPI from "@/api/checklists";

import moment from "moment";

export default {
  data() {
    return {
      search: null,
      templates: [],
      selectedTag: null,
    };
  },
  methods: {
    selectTemplate(template) {
      this.$router.push({
        name: "checklist_editor",
        params: {
          id: template._id,
        },
      });
    },
    createNew() {
      ChecklistsAPI.createTemplate(this.cafe._id).then((data) => {
        this.selectTemplate(data.template);
      });
    },
    fetchData() {
      ChecklistsAPI.getTemplates(this.cafe._id).then((data) => {
        this.templates = data.templates;
      });
    },
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    filteredTemplates() {
      let templates = this.templates;

      if (this.selectedTag)
        templates = templates.filter((t) => t.tags.includes(this.selectedTag));

      if (!this.search) return templates;

      return templates.filter((t) => {
        return t.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    allTags() {
      let tags = [];

      for (const template of this.templates) {
        tags = [...tags, ...template.tags];
      }

      return Array.from(new Set(tags).values());
    }
  },
  components: {
    ChecklistFormCard
  },
};
</script>

<style>
.checklists-forms-global-container {
  padding: 16px 52px !important;
}
</style>

<style scoped>
.add-form-button {
  align-items: center;
  justify-content: center;
}

.summary-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.tags-filter {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
}

.templates-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.grid-card {
  width: calc(33.333% - 11px);
}

.reports-list {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.group-title {
  align-items: center;
}

.no-reports {
  display: flex;
  height: 100%;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 16px;
}
</style>
